// جدول التوزيع: مبلغ واحد مقسّم على عدة بنود.
//
// محوران قابلان للقلب لأن الحالتين متطابقتان الشكل:
//   رسوم المدرسة → نوع ثابت (مدرسة) × مبالغ لكل وجهة (أحمد ٥، علي ٤، آية ٣)
//   فاتورة المول → وجهة ثابتة (البيت) × مبالغ لكل نوع (تموين ٢٠٠، خضار ١٥٠)
//
// وهي عمداً رابط صغير لا زر رئيسي: من يقسّم كل زيارة بقالة يكون قد وظّف نفسه محاسباً.

import { fmt, money, esc } from '../util.js';
import { addEntry, destName, typeName, baseCur, baseSym } from '../store.js';
import { orderedDests, orderedTypes } from '../model.js';
import { keypad, backBar } from '../ui.js';
import * as calc from '../calc.js';

export function freshDraft(){
  return { axis: 'dest', anchorId: null, values: {}, active: null, calc: calc.create() };
}

/** يثبّت ناتج الحاسبة في الخانة النشطة — يُستدعى بعد كل ضغطة ليبقى المجموع حيّاً. */
function commit(d){
  if (!d.active) return;
  const v = calc.value(d.calc);
  if (v && v > 0) d.values[d.active] = v;
  else delete d.values[d.active];
}

function lists(app){
  const byDest = app.splitDraft.axis === 'dest';
  return {
    byDest,
    rows: byDest ? orderedDests() : orderedTypes(),
    anchors: byDest ? orderedTypes() : orderedDests()
  };
}

export function render(app){
  const d = app.splitDraft;
  const { byDest, rows, anchors } = lists(app);
  const sym = baseSym();

  if (!d.anchorId && anchors.length) d.anchorId = anchors[0].id;

  let total = 0;
  rows.forEach(r => { total += +(d.values[r.id] || 0); });
  const n = rows.filter(r => d.values[r.id]).length;

  return backBar('توزيع مبلغ واحد',
      byDest ? 'نوع واحد · مبلغ مستقل لكل وجهة' : 'وجهة واحدة · مبلغ مستقل لكل نوع')
    + `<div class="seg">
        <button type="button" data-axis="dest" aria-pressed="${byDest}">وزّع على وجهات</button>
        <button type="button" data-axis="type" aria-pressed="${!byDest}">وزّع على أنواع</button>
      </div>`
    + `<div class="dim ${byDest ? 't' : 'd'}">
        <div class="lab">${byDest ? 'النوع الثابت' : 'الوجهة الثابتة'}</div>
        <div class="strip">${anchors.map(a =>
          `<button type="button" class="pill" data-anchor="${a.id}" aria-pressed="${a.id === d.anchorId}">${esc(a.name)}</button>`
        ).join('')}</div></div>`
    + `<div class="scroll">${rows.map(r => {
        const v = d.values[r.id];
        return `<button type="button" class="row" data-split="${r.id}" aria-current="${d.active === r.id}">
          <span class="nm">${esc(r.name)}</span>
          <span class="val${v ? '' : ' dim'}">${v ? calc.formatValue(v) : '—'}</span>
        </button>`;
      }).join('')}
        <div class="total"><span>المجموع</span><span class="mono">${money(total)} ${sym}</span></div></div>`
    + keypad()
    + `<button type="button" class="cta" data-act="savesplit" ${total > 0 ? '' : 'disabled'}>
        حفظ ${n} ${n === 1 ? 'حركة' : 'حركات'} · ${money(total)} ${sym}</button>`;
}

export function onClick(app, btn){
  const d = app.splitDraft;

  if (btn.dataset.key){
    if (!d.active) return;
    d.calc = calc.press(d.calc, btn.dataset.key);
    commit(d);
    return app.render();
  }
  if (btn.dataset.axis){
    if (d.axis !== btn.dataset.axis){
      d.axis = btn.dataset.axis;
      d.values = {}; d.active = null; d.anchorId = null; d.calc = calc.create();
    }
    return app.render();
  }
  if (btn.dataset.anchor){ d.anchorId = btn.dataset.anchor; return app.render(); }
  if (btn.dataset.split){
    const id = btn.dataset.split;
    // ضغطة ثانية على الخانة النشطة تفتح الحاسبة
    if (d.active === id){
      return app.openCalc(calc.value(d.calc), v => {
        d.calc = calc.fromNumber(v);
        commit(d);
        app.render();
      });
    }
    commit(d);                       // نثبّت الخانة السابقة قبل مغادرتها
    d.active = id;
    d.calc = calc.fromNumber(d.values[id]);
    return app.render();
  }

  if (btn.dataset.act === 'savesplit'){
    commit(d);                       // آخر خانة قد تحمل تعبيراً لم يُثبَّت
    const byDest = d.axis === 'dest';
    const made = [];
    let i = 0;
    Object.keys(d.values).forEach(id => {
      const v = +d.values[id];
      if (!v) return;
      const e = addEntry({
        amount: v,
        destId: byDest ? id : d.anchorId,
        typeId: byDest ? d.anchorId : id,
        currency: baseCur(),
        occurredAt: new Date(Date.now() + (i++))
      });
      made.push(e.id);
    });
    if (!made.length) return;
    const anchorLabel = byDest ? (typeName(d.anchorId) || '') : destName(d.anchorId);
    app.splitDraft = freshDraft();
    app.closeSub();
    app.toast(`حُفظت ${made.length} حركات · ${anchorLabel}`, 'تراجع', () => app.undoEntries(made));
    app.queueSync();
    return;
  }
  return false;
}
